import { Connection } from "@solana/web3.js"

// Get network from environment
export const SOLANA_NETWORK = (import.meta.env.VITE_SOLANA_NETWORK || "devnet") as "devnet" | "mainnet-beta"

// Get RPC URL - prioritize Helius endpoints if available
function getDefaultRpcUrl(network: "devnet" | "mainnet-beta"): string {
  // Check for Helius endpoints first
  if (network === "devnet" && import.meta.env.VITE_HELIUS_API_KEY) {
    return import.meta.env.VITE_HELIUS_API_KEY
  }
  if (network === "mainnet-beta" && import.meta.env.VITE_HELIUS_MAINNET_API_KEY) {
    return import.meta.env.VITE_HELIUS_MAINNET_API_KEY
  }
  // Fall back to public RPCs
  return network === "devnet"
    ? "https://api.devnet.solana.com"
    : "https://api.mainnet-beta.solana.com"
}

// Get RPC URL
export const RPC_URL = import.meta.env.VITE_SOLANA_RPC_URL || getDefaultRpcUrl(SOLANA_NETWORK)

// Create connection singleton
let connection: Connection | null = null

export function getConnection(): Connection {
  if (!connection) {
    connection = new Connection(RPC_URL, {
      commitment: "confirmed",
      confirmTransactionInitialTimeout: 60000,
    })
  }
  return connection
}

// Helper to get RPC URL for a specific network (useful for server actions)
export function getRpcUrlForNetwork(network: "devnet" | "mainnet-beta" = SOLANA_NETWORK): string {
  // ALWAYS prioritize network-specific Helius endpoints first
  if (network === "devnet" && import.meta.env.VITE_HELIUS_API_KEY) {
    return import.meta.env.VITE_HELIUS_API_KEY
  }
  if (network === "mainnet-beta" && import.meta.env.VITE_HELIUS_MAINNET_API_KEY) {
    return import.meta.env.VITE_HELIUS_MAINNET_API_KEY
  }

  // DO NOT use generic NEXT_PUBLIC_SOLANA_RPC_URL here - it might be for the wrong network!
  // Only use it if it matches the requested network (check by URL pattern)
  if (import.meta.env.VITE_SOLANA_RPC_URL) {
    const rpcUrl = import.meta.env.VITE_SOLANA_RPC_URL
    const isMainnet = rpcUrl.includes('mainnet')
    const isDevnet = rpcUrl.includes('devnet')

    // Only use if it matches the requested network
    if ((network === "mainnet-beta" && isMainnet) || (network === "devnet" && isDevnet)) {
      return rpcUrl
    }
    // If it doesn't match, ignore it and fall through to public RPCs
  }

  // Fall back to public RPCs
  return getDefaultRpcUrl(network)
}
